function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_1921",
  d: "M523.3,6483.975a.937.937,0,0,0-1.574.422.928.928,0,0,0,.244.9l2.25,2.251a.19.19,0,0,1,.055.135.194.194,0,0,1-.055.136l-2.25,2.25a.935.935,0,0,0-.257.91.954.954,0,0,0,.672.678.943.943,0,0,0,.915-.264l2.249-2.25a.195.195,0,0,1,.266,0l2.25,2.25a.936.936,0,0,0,1.573-.421.927.927,0,0,0-.243-.9l-2.249-2.25a.194.194,0,0,1-.055-.136.19.19,0,0,1,.055-.135l2.249-2.251a.938.938,0,1,0-1.33-1.324l-2.25,2.251a.2.2,0,0,1-.266,0Z",
  transform: "translate(-521.683 -6483.686)",
  fill: "#6a6467"
});

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8.001,
    viewBox: "0 0 8 8.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close.40662c6e.svg";
export { ForwardRef as ReactComponent };